import { render, staticRenderFns } from "./PqrPage.vue?vue&type=template&id=4fb98754"
import script from "./PqrPage.vue?vue&type=script&lang=js"
export * from "./PqrPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports